import React, { FC } from 'react'
import styles from './NoDataContainer.scss'
import { PendingDeliveryIcon } from '../../assets/icons/PendingDeliveryIcon'

interface NoDataContainerProps {
  verticalName: string
  zoneName?: string
}

const NoDataContainer: FC<NoDataContainerProps> = ({ verticalName }) => {
  return (
    <div className={styles.pendingDeliveryContainer}>
      <div className={styles.iconWrapper}>
        <PendingDeliveryIcon size={80} />
      </div>
      <div className={styles.textContent}>
        <h1>PENDING DELIVERY</h1>
        <p>
          The <span className={styles.verticalHighlight}>{verticalName}</span> vertical is not available yet.
        </p>
        <p>It will be available in a future release.</p>
      </div>
    </div>
  )
}

export default NoDataContainer
